module.exports = __webpack_public_path__ + "img/chat.b82751c7.webp";